module.exports = __webpack_public_path__ + "static/media/SE_IPPF_logo.1243794e.png";